import {Component, Input } from '@angular/core';
import {ListeChoix} from '../../../shared/ListeChoix/listeChoix.model';

@Component({
    selector: 'jhi-choix-component',
    templateUrl: 'choix.component.html'
})
export class ChoixComponent {

    @Input() choix: ListeChoix[];

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/blocks/choix/choix.component.ts